/**
 * Module dependencies.
 */

import { cn } from 'app/lib/utils';
import React from 'react';

/**
 * `Props` type.
 */

type Props = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> & {
  active?: boolean;
  label: string;
};

/**
 * Export `ToolButton` component — an icon button for the editor toolbar and
 * bubble menu, with a pressed state for active marks/nodes.
 */

export const ToolButton = React.forwardRef<HTMLButtonElement, Props>(function ToolButton(
  { active, className, label, ...props },
  ref
) {
  return (
    <button
      aria-label={label}
      aria-pressed={active}
      className={cn(
        'inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground disabled:pointer-events-none disabled:opacity-40 [&_svg]:h-4 [&_svg]:w-4',
        active && 'bg-primary/10 text-primary hover:bg-primary/15 hover:text-primary',
        className
      )}
      ref={ref}
      title={label}
      type={'button'}
      {...props}
    />
  );
});

/**
 * Export `ToolDivider` component.
 */

export function ToolDivider(): JSX.Element {
  return <span aria-hidden className={'mx-1 h-5 w-px shrink-0 bg-border'} />;
}
